import { Thread } from "@/components/assistant-ui/thread";
import {
  useConversations,
  useRefeshConversationOnNewThread,
} from "@/features/Prompt/useConversations";
import { useThreadLoader } from "@/features/Prompt/useThreadLoader";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { AIConversation } from "../../features/Prompt/schema";
import { ThreadListNew } from "../assistant-ui/thread-list";
import LayoutSidebar from "../LayoutSidebar";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "../ui/sidebar";

/**
 * Thread item component for displaying a single conversation in the sidebar
 * @param thread - Thread/conversation data
 */
export function ThreadItem({ thread }: { thread: AIConversation }) {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild>
        <Link to={`conversations/${thread.id}`}>
          <span>{thread.title || "No title"}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}

/**
 * ThreadSidebar component to display the list of conversations
 */
function ThreadSidebar() {
  const { data } = useConversations();

  useRefeshConversationOnNewThread();

  return (
    <Sidebar>
      <SidebarHeader>
        <ThreadListNew />
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Conversations</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {data?.map((thread) => (
                <ThreadItem key={thread.id} thread={thread} />
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter />
    </Sidebar>
  );
}

type PromptProps = {
  tools?: ReactNode;
};

/**
 * Main Prompt component that renders the conversation UI
 */
export default function Prompt({ tools }: PromptProps) {
  const { isLoading } = useThreadLoader();

  return (
    <div className="default-scrollbar overflow-hidden">
      <LayoutSidebar
        sidebar={<ThreadSidebar />}
        main={<Thread isLoading={isLoading} />}
        tools={tools}
      />
    </div>
  );
}
